import { NewSetupApp } from './NewSetupApp';
import { registerReactWebComponent } from '@/core/utils/webComponent';

export const registerNewSetupComponent = () => {
  registerReactWebComponent('content-new-setup', NewSetupApp, () => ({}));
};
